import React from 'react';

interface SpecimenProps {
  label: string;
  children: React.ReactNode;
}

/** One labelled cell in the preview grid. */
export default function Specimen ({ label, children }: SpecimenProps) {
  return (
    <div className='ds-flex ds-flex-col ds-gap-2'>
      <span className='ds-text-ds-mini ds-text-muted-foreground'>{label}</span>
      <div className='ds-flex ds-items-center ds-gap-2'>{children}</div>
    </div>
  );
}

interface SectionProps {
  title: string;
  children: React.ReactNode;
}

export function Section ({ title, children }: SectionProps) {
  return (
    <section className='ds-flex ds-flex-col ds-gap-4'>
      <h2 className='ds-text-ds-h3 ds-font-medium ds-text-foreground'>{title}</h2>
      <div className='ds-flex ds-flex-col ds-gap-6'>{children}</div>
    </section>
  );
}

export function Row ({ children }: { children: React.ReactNode }) {
  return <div className='ds-flex ds-flex-wrap ds-items-end ds-gap-6'>{children}</div>;
}
